// client.ts
import { Timestamp } from 'firebase/firestore';

export class Client {
    client_id: string = '';
    user_id: string = '';
    name: string = '';
    date_of_birth: Date = new Date();
    age: string = '';
    gender: string = '';
    phone_number: string = '';
    email: string = '';
    profile_image_url: string = '';

    constructor(init?: Partial<Client>) {
        Object.assign(this, init);
    }

    static fromFirestore(id: string, data: any): Client {
        let parsedDob: Date = new Date(0); // Default to epoch as "no date"
        if (data.date_of_birth) {
            // Check for Firestore Timestamp (has toDate method) or seconds/nanoseconds structure
            if (typeof data.date_of_birth.toDate === 'function') {
                parsedDob = data.date_of_birth.toDate();
            } else if (data.date_of_birth.seconds !== undefined) {
                // Raw Firestore timestamp object
                parsedDob = new Date(data.date_of_birth.seconds * 1000);
            } else if (data.date_of_birth instanceof Date) {
                parsedDob = data.date_of_birth;
            } else {
                const parsed = new Date(data.date_of_birth);
                if (!isNaN(parsed.getTime())) {
                    parsedDob = parsed;
                }
            }
        }

        return new Client({
            client_id: id,
            user_id: data.user_id ?? '',
            name: data.name ?? '',
            date_of_birth: parsedDob,
            age: data.age ?? '',
            gender: data.gender ?? '',
            phone_number: data.phone_number ?? '',
            email: data.email ?? '',
            profile_image_url: data.profile_image_url ?? ''
        });
    }

    toFirestore() {
        return {
            user_id: this.user_id,
            name: this.name,
            date_of_birth: this.date_of_birth,
            age: this.age,
            gender: this.gender,
            phone_number: this.phone_number,
            email: this.email,
            profile_image_url: this.profile_image_url
        };
    }
}
